import React, { useEffect, useRef } from 'react';
import hljs from 'highlight.js';
// import 'highlight.js/styles/github.css';

interface SyntaxHighlighterProps {
  code: string;
  language: string;
  className?: string;
}

export const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({
  code,
  language,
  className = '',
}) => {
  const codeRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (codeRef.current) {
      // Clear previous highlighting
      codeRef.current.innerHTML = '';

      // Highlight the code
      const highlightedCode = hljs.highlight(code, { language }).value;
      codeRef.current.innerHTML = highlightedCode;
    }
  }, [code, language]);

  return (
    <pre className={`hljs ${className}`} style={{ margin: 0, padding: 0 }}>
      <code
        ref={codeRef}
        className={`language-${language}`}
        style={{
          fontFamily:
            'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
          fontSize: '0.875rem',
          lineHeight: '1.5',
        }}
      />
    </pre>
  );
};
